import { render } from "./FadeIn.vue?vue&type=template&id=2e959510"
const script = {}

import "./FadeIn.vue?vue&type=style&index=0&id=2e959510&lang=css"
script.render = render

export default script